export default {
  name: 'RenderDom',
  functional: true,
  props: {
    render: Function,
    props: Object | String
  },
  render: (h, ctx) => {
    return ctx.props.render && ctx.props.render(h, ctx.props.props)
  }
}
